import { render, staticRenderFns } from "./VideoRecorder.vue?vue&type=template&id=557226a0"
import script from "./VideoRecorder.vue?vue&type=script&lang=js"
export * from "./VideoRecorder.vue?vue&type=script&lang=js"
import style0 from "./VideoRecorder.vue?vue&type=style&index=0&id=557226a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports